/** The New namespace form: its Name, its Key, and whether the Key was typed. */
export interface NamespaceDraft {
  name: string;
  key: string;
  /** The user typed the Key, so the Name no longer fills it in. */
  keyEdited: boolean;
}

export const emptyNamespaceDraft: NamespaceDraft = {
  name: '',
  key: '',
  keyEdited: false,
};

/** The longest Key the namespaces contract accepts. */
const NAMESPACE_KEY_MAX = 10;

/** A Key suggested from a Name: its ASCII letters and digits, uppercased, up to 10. */
export function namespaceKeyFromName(name: string): string {
  return name
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, '')
    .slice(0, NAMESPACE_KEY_MAX);
}

/** A new Name, which also fills in the Key until the user types one. */
export function withNamespaceName(
  draft: NamespaceDraft,
  name: string,
): NamespaceDraft {
  return {
    ...draft,
    name,
    key: draft.keyEdited ? draft.key : namespaceKeyFromName(name),
  };
}

/** A typed Key, which stops the Name filling it in; clearing it resumes that. */
export function withNamespaceKey(
  draft: NamespaceDraft,
  key: string,
): NamespaceDraft {
  return { ...draft, key, keyEdited: key !== '' };
}
